<a
  href="javascript:void(0)"
  class="btn btn-sm btn-circle btn-secondary-primary"
  (click)="onShow()"
  [matTooltip]="tooltipText"
>
  <i class="cs-icon cs-icon-ai"></i>
</a>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="isDropdownOpen = false"
  [cdkConnectedOverlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' }
  ]"
  [cdkConnectedOverlayOrigin]="attachTo"
  [cdkConnectedOverlayWidth]="width"
  [cdkConnectedOverlayMinWidth]="minWidth"
  [cdkConnectedOverlayMinHeight]="140"
  [cdkConnectedOverlayOpen]="isDropdownOpen"
>
  <div class="d-flex flex-column p-3 bg-white shadow2 border rounded w-100">
    <div class="mb-2" *ngIf="suggestions.length > 0 && !isLoading" style="max-height: 100px; overflow-y: auto">
      {{ suggestions[selectedSuggestionIndex] }}
    </div>
    <div class="text-center text-light text-sm" *ngIf="!isLoading && suggestions.length === 0">
      <ng-container i18n>No suggestions found. Please try again.</ng-container>
    </div>
    <div *ngIf="isLoading">
      <app-loading-section
        padding="2rem 0"
        size="1rem"
        color="var(--primary)"
        icon="cs-icon cs-icon-ai-blink"
        spinStyle="fa-beat"
      >
        <div class="text-center text-sm">
          <div class="text-dark" i18n>Analyzing data...Hang tight</div>
          <div class="text-light" i18n>AI is preparing the latest data for you.</div>
        </div>
      </app-loading-section>
    </div>
    <div class="d-flex gap-3 align-items-center mt-auto" *ngIf="!isLoading">
      <ng-container *ngIf="!isLoading && suggestions.length > 2">
        <!-- Previous -->
        <button class="btn btn-outline-light btn-sm btn-circle" (click)="onPrevious()">
          <i class="far fa-chevron-left"></i>
        </button>
        <div>{{ selectedSuggestionIndex + 1 }} / {{ suggestions.length }}</div>
        <!-- Next -->
        <button class="btn btn-outline-light btn-sm btn-circle" (click)="onNext()">
          <i class="far fa-chevron-right"></i>
        </button>
      </ng-container>
      <div class="flex-fill"></div>

      <div dropdown class="btn-group" [dropup]="true">
        <button
          dropdownToggle
          type="button"
          class="btn btn-secondary-warning btn-sm dropdown-toggle"
          i18n-matTooltip
          matTooltip="You can perform multiple actions using this button."
        >
          <span class="cs-icon cs-icon-cog"></span> <ng-container i18n>More Options</ng-container>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
          <li class="disabled">
            <a class="dropdown-item disabled pl-0" href="javascript:void(0)" i18n>Adjust length</a>
          </li>
          <li>
            <button type="button" (click)="onShorten()">
              <ng-container i18n>Shorten</ng-container>
            </button>
          </li>
          <li>
            <button (click)="onExpand()" type="button">
              <ng-container i18n>Expand</ng-container>
            </button>
          </li>
          <li class="dropdown-divider"></li>
          <li class="disabled">
            <a class="dropdown-item disabled pl-0" href="javascript:void(0)" i18n>Change tone</a>
          </li>
          <li *ngFor="let tone of toneOptions">
            <button type="button" (click)="onTone(tone)">
              {{ tone | titleCase }}
            </button>
          </li>
        </ul>
      </div>
      <button
        class="btn btn-secondary-info btn-sm"
        matTooltip="Regenerate the suggestions"
        i18n-matTooltip
        (click)="onRefresh()"
      >
        <i class="far fa-refresh"></i>
      </button>

      <!-- Apply -->
      <button
        class="btn btn-primary btn-sm"
        (click)="onApply(suggestions[selectedSuggestionIndex])"
        [disabled]="!suggestions[selectedSuggestionIndex]"
      >
        <i class="far fa-check"></i> <ng-container i18n>Apply</ng-container>
      </button>
    </div>
  </div>
</ng-template>
